/**
 * Smatchy
 * The smatchy API description. Use POST /auth/login to get an access token.
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { AdminUserTypeDto } from './adminUserTypeDto';


export interface AdminUserManagementListItemDto { 
    id: string;
    name: string;
    email: string;
    avatar: string;
    /**
     * City declared on the profile, empty string when not set.
     */
    city: string;
    /**
     * Profile completion percentage (0-100), computed from the fields available today. See infra/profile-completion.ts for the weighting and what is not yet scored.
     */
    profileCompletion: number;
    /**
     * How warm this person is, from what they have done rather than from when they last logged in. Same boundaries as the segments endpoint. Absent means not computed, which is not the same statement as never having acted.
     */
    temperature?: AdminUserManagementListItemDto.TemperatureEnum;
    userType?: AdminUserTypeDto;
    status: AdminUserManagementListItemDto.StatusEnum;
    activities: number;
    sportsCount: number;
    notification: boolean;
    lastLoginDate?: string;
    /**
     * ISO timestamp from userprofiles.lastLoginAt
     */
    lastLoginAt?: string;
    firstName?: string;
    lastName?: string;
    createdAt?: string;
    /**
     * False when the account exists in users but has no userprofiles row yet
     */
    hasProfile: boolean;
}
export namespace AdminUserManagementListItemDto {
    export type TemperatureEnum = 'hot' | 'warm' | 'cool' | 'frozen' | 'never';
    export const TemperatureEnum = {
        Hot: 'hot' as TemperatureEnum,
        Warm: 'warm' as TemperatureEnum,
        Cool: 'cool' as TemperatureEnum,
        Frozen: 'frozen' as TemperatureEnum,
        Never: 'never' as TemperatureEnum
    };
    export type StatusEnum = 'Active' | 'Inactive';
    export const StatusEnum = {
        Active: 'Active' as StatusEnum,
        Inactive: 'Inactive' as StatusEnum
    };
}


